import { UseQueryResult, useQuery } from "@tanstack/react-query";
import NotificationsTypeResponse from "../../../models/API/responseModels/notificationsTypeResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useNotificationsType(): UseQueryResult<
  NotificationsTypeResponse,
  any
> {
  const { authState } = useOktaAuth();
  return useQuery({
    queryKey: ["notificationType"],
    queryFn: () =>
      axiosInstance
        .get("/v1/notification-types", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken,
  });
}

export default useNotificationsType;
